<template>
  <div>
    <!-- <v-head></v-head> -->
    <!-- <div style="width: 100%; background-color: #fff">
      <div class="infoDetailsBox_header">
        <div class="logo" @click="$router.push('/index')">
          <img src="/static/image/newLogo.png" />
          <div class="line"></div>
          <div class="logo-des">
            <p>消费帮促</p>
            <p>采购平台</p>
          </div>
        </div>
        <div class="headerContent">
          <img class="headerImg" src="/static/image/infoTop.png" />
          <div>—— 资讯中心 ——</div>
        </div>
      </div>
    </div> -->
    <div class="infoDetailsBox">
      <!-- <div class="infoDetails_title">{{ infoData.title }}</div> -->
      <div v-html="infoData.content" style="width:100%"></div>
    </div>
  </div>
</template>
<script>
import vHead from "../common/header2.vue";
import { doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  components: { vHead },
  data() {
    return {
      infoData: ""
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.id != 0) {
        this.getData(this.$route.query.id);
      } else {
        this.infoData = {
          content:
            '<div style="display:flex;align-items:flex-start;justify-content:space-between;"><img src="/static/image/goods1.jpg" style="height:628px;"><div style="width:700px"><p>产品参数：</p><p>型号: YYASYJ</p><p>品牌: 艾氏壹家</p><p>材质: 无纺布</p><p>产地: 湖北</p><p>颜色分类: 成人蓝【100片】医用外科 成人蓝【300片】医用外科 成人蓝【200片】单片独立装 医用外科（灭菌升级版) 成人蓝【100片】单片独立装 医用外科（灭菌升级版) 成人蓝【50片】单片独立装 医用外科（灭菌升级版) 成人蓝【500片】单片独立装 医用外科（灭菌升级版) 成人蓝【100只】每袋十只【灭菌款】 成人蓝【500只】每袋十只【灭菌款】 成人蓝【1000只】每袋十只【灭菌款】 儿童阳光象【100片】单片独立装 医用外科 儿童宇航员【100片】单片独立装 医用外科 儿童白【100片】单片独立装 医用外科 成人黑100片单片独立灭菌升级版 成人白【100片】单片独立装 灭菌升级版 儿童卡通恐龙【200片】单片独立装 医用外科 儿童白【200片】单片独立装 医用外科 儿童宇航员【200片】单片独立装 医用外科 成人蓝【1000片】医用外科 成人蓝【2000片】医用外科</p><p>生产企业: 湖北中融达医疗器械有限公司</p><p>增值服务: 过年不打烊 现货速发</p><p>适用人群: 不限 儿童 女性 成人</p><p>注册证号: 鄂械注准20222143730</p><p>选购热点: 一次性 防病菌</p><p>医疗器械产品名称: 医用外科口罩</p></div></div><div style="display:flex;align-items:flex-start;justify-content:space-between;"><div style="width:700px"><p>型号: CMS50D</p><p>品牌: Contec</p><p>产地: 秦皇岛</p><p>颜色分类: 1个0303 1个 测试</p><p>适用部位: 手指</p><p>生产企业: 康泰医学系统(秦皇岛)股份有限公司</p><p>执行标准号: 冀食药监械（准）字2011第2210055号</p><p>增值服务: 正品保障</p><p>适用人群: 不限</p><p>疾病: 哮喘 支气管炎 高原缺氧病症</p><p>症状: 呼吸困难 头昏 心悸 无力 缺氧</p><p>注册证号: 冀械注准20192070190</p><p>医疗器械产品名称: 脉搏血氧仪</p></div><img src="/static/image/goods2.jpg" style="height:555px;"></div>'
        };
      }
    }
  },
  mounted() {
    if (this.$route.query.id != 0) {
      this.getData(this.$route.query.id);
    } else {
      this.infoData = {
        content:
          '<div style="display:flex;align-items:flex-start;justify-content:space-between;"><img src="/static/image/goods1.jpg" style="height:628px;"><div style="width:700px"><p>产品参数：</p><p>型号: YYASYJ</p><p>品牌: 艾氏壹家</p><p>材质: 无纺布</p><p>产地: 湖北</p><p>颜色分类: 成人蓝【100片】医用外科 成人蓝【300片】医用外科 成人蓝【200片】单片独立装 医用外科（灭菌升级版) 成人蓝【100片】单片独立装 医用外科（灭菌升级版) 成人蓝【50片】单片独立装 医用外科（灭菌升级版) 成人蓝【500片】单片独立装 医用外科（灭菌升级版) 成人蓝【100只】每袋十只【灭菌款】 成人蓝【500只】每袋十只【灭菌款】 成人蓝【1000只】每袋十只【灭菌款】 儿童阳光象【100片】单片独立装 医用外科 儿童宇航员【100片】单片独立装 医用外科 儿童白【100片】单片独立装 医用外科 成人黑100片单片独立灭菌升级版 成人白【100片】单片独立装 灭菌升级版 儿童卡通恐龙【200片】单片独立装 医用外科 儿童白【200片】单片独立装 医用外科 儿童宇航员【200片】单片独立装 医用外科 成人蓝【1000片】医用外科 成人蓝【2000片】医用外科</p><p>生产企业: 湖北中融达医疗器械有限公司</p><p>增值服务: 过年不打烊 现货速发</p><p>适用人群: 不限 儿童 女性 成人</p><p>注册证号: 鄂械注准20222143730</p><p>选购热点: 一次性 防病菌</p><p>医疗器械产品名称: 医用外科口罩</p></div></div><div style="display:flex;align-items:flex-start;justify-content:space-between;"><div style="width:700px"><p>型号: CMS50D</p><p>品牌: Contec</p><p>产地: 秦皇岛</p><p>颜色分类: 1个0303 1个 测试</p><p>适用部位: 手指</p><p>生产企业: 康泰医学系统(秦皇岛)股份有限公司</p><p>执行标准号: 冀食药监械（准）字2011第2210055号</p><p>增值服务: 正品保障</p><p>适用人群: 不限</p><p>疾病: 哮喘 支气管炎 高原缺氧病症</p><p>症状: 呼吸困难 头昏 心悸 无力 缺氧</p><p>注册证号: 冀械注准20192070190</p><p>医疗器械产品名称: 脉搏血氧仪</p></div><img src="/static/image/goods2.jpg" style="height:555px;"></div>'
      };
    }
  },
  methods: {
    getData(id) {
      var that = this;
      doGet(
        httpConfig.infoDetails.getDataUrl,
        { id: id },
        function(res) {
          that.infoData = res;
        },
        function(res) {}
      );
    }
  }
};
</script>
<style scoped>
@import "../../assets/css/infoDetails";
</style>



// WEBPACK FOOTER //
// src/components/page/infoDetails.vue